export default __webpack_public_path__ + "static/media/10d.a6b051e1.svg";